// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scene-root[data-v-f81410fa] {\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://./resources/js/components/scenes/SceneRoot.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".scene-root[data-v-f81410fa] {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
